import React, { useState, useEffect } from 'react';

const FooterSection = () => {
    const [data, setData] = useState({
        company: {
            name: "MobiCloud",
            description: "Shaping the Digital Destiny of Businesses through innovative technology solutions.",
            logo: "/img/mobicloud-logo.png"
        },
        services: [
            { text: "Cloud Services", link: "#services" },
            { text: "Digital Transformation", link: "#services" },
            { text: "Application Services", link: "#services" },
            { text: "Engineering Services", link: "#services" },
            { text: "Mobile Apps", link: "#services" },
            { text: "AI & Machine Learning", link: "#services" }
        ],
        products: [
            // Removed specific product links as requested
        ],
        companyLinks: [
            { text: "About Us", link: "#about" },
            // { text: "Our Team", link: "#team" },
            { text: "Careers", link: "#contact" },
            { text: "Contact Us", link: "#contact" },
            { text: "Privacy Policy", link: "/privacy-policy" },
            { text: "Terms of Service", link: "/terms-of-service" }
        ],
        contact: {
            email: "admin@mobicloud.ai"
        },
        social: {
            linkedin: "#",
            twitter: "#",
            facebook: "#",
            instagram: "#"
        }
    });

    return (
        <footer className="footer-area bg-dark text-white">
            <div className="container">
                <div className="row pt-5 pb-4">
                    {/* Company Info */}
                    <div className="col-12 col-lg-4 mb-4">
                        <div className="footer-widget">
                            <div className="footer-logo mb-3">
                                <img src={data.company.logo} alt={data.company.name} style={{height: '50px'}} />
                            </div>
                            <p className="text-white-50 mb-4">{data.company.description}</p>
                            <div className="social-links">
                                <a href={data.social.linkedin} className="text-white-50 me-3">
                                    <i className="fab fa-linkedin fa-lg"></i>
                                </a>
                                <a href={data.social.twitter} className="text-white-50 me-3">
                                    <i className="fab fa-twitter fa-lg"></i>
                                </a>
                                <a href={data.social.facebook} className="text-white-50 me-3">
                                    <i className="fab fa-facebook fa-lg"></i>
                                </a>
                                <a href={data.social.instagram} className="text-white-50">
                                    <i className="fab fa-instagram fa-lg"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Services */}
                    <div className="col-12 col-md-6 col-lg-2 mb-4">
                        <div className="footer-widget">
                            <h5 className="mb-3">Services</h5>
                            <ul className="list-unstyled">
                                {data.services.map((service, idx) => (
                                    <li key={idx} className="mb-2">
                                        <a href={service.link} className="text-white-50 text-decoration-none">
                                            {service.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Products - Hidden as no products are listed */}
                    {/* <div className="col-12 col-md-6 col-lg-2 mb-4">
                        <div className="footer-widget">
                            <h5 className="mb-3">Products</h5>
                            <ul className="list-unstyled">
                                {data.products.map((product, idx) => (
                                    <li key={idx} className="mb-2">
                                        <a href={product.link} className="text-white-50 text-decoration-none">
                                            {product.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div> */}

                    {/* Company */}
                    <div className="col-12 col-md-6 col-lg-2 mb-4">
                        <div className="footer-widget">
                            <h5 className="mb-3">Company</h5>
                            <ul className="list-unstyled">
                                {data.companyLinks.map((link, idx) => (
                                    <li key={idx} className="mb-2">
                                        <a href={link.link} className="text-white-50 text-decoration-none">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="col-12 col-md-6 col-lg-2 mb-4">
                        <div className="footer-widget">
                            <h5 className="mb-3">Contact</h5>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <a href={`mailto:${data.contact.email}`} className="text-white-50 text-decoration-none">
                                        <i className="fas fa-envelope me-2"></i>
                                        {data.contact.email}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="row border-top border-secondary pt-4">
                    <div className="col-12 text-center">
                        <p className="text-white-50 mb-0">
                            © Copyright 2024 {data.company.name}. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterSection; 